import React from "react";
import styles from "./moon.module.css";
import { Page } from "../../../components/page/page";
import { ContinueButton } from "../../../../../components/continue-button/continue-button";

const MoonPage = () => {
  const buttonStyles = {
    backgroundColor: "#ffffff",
    color: "#3C3B19",
    position: 'relative',
    zIndex: '1'
  };
  return (
    <div className={styles.page}>
      <Page
        title="The phase of the moon is often believed to influence psychic abilities like clairvoyance, as each phase carries different energy that can either enhance or diminish intuitive powers"
        hideSteps="true"
        hideContinueButton="true"
      >
        <ContinueButton
          link="../your-birthdate"
          additionalClassName={styles.button}
          buttonStyles={buttonStyles}
        ></ContinueButton>
      </Page>
    </div>
  );
};

export { MoonPage };
